import React from 'react';
import '../modalRight/modalRight.scss';

const ErrorModal = ({ isOpen, onClose, title, error }) => {
	const date = new Date();
	const ThisYear = date.getFullYear().toString().slice(-2);
	const Thismonth = (date.getMonth() + 1).toString().padStart(2, '0');

	function getUniqueNestedArray(nestedArray) {
		return nestedArray.map((innerArray) => {
			return [...new Set(innerArray)];
		});
	}

	function createNestedArray(errors) {
		const nestedArray = [];
		errors?.length > 0 &&
			errors?.forEach((error) => {
				const pathIndex = error?.index;
				const message = error?.field || error?.name;
				const customErrorMessage = error?.customErrorMessage || '';

				if (!nestedArray[pathIndex]) {
					nestedArray[pathIndex] = [];
				}

				nestedArray[pathIndex].push({ message, customErrorMessage });
			});
		return getUniqueNestedArray(nestedArray);
	}

	const GetErrorData = (name, customErrorMessage = '') => {
		switch (name) {
			case 'batch_no':
				return customErrorMessage?.batch_no || 'Batch No can not be empty.';
			case 'product_exist':
				return 'This product already exists in the Purchase order.';
			case 'order_quantity':
				return 'Quantity can be accepted number except 0';
			case 'product_packaging':
				return 'Package name can not be empty.';
			case 'quantity':
				return 'Quantity can be accepted number except 0';
			case 'qty':
				return customErrorMessage.qty || 'Quantity can be accepted number except 0';
			case 'mfg_date':
				return `MFG date can not be greater than ${Thismonth}/${ThisYear}`;
			case 'mrp':
				return 'MRP can not be empty';
			case 'amount':
				return 'Amount can not be empty or 0';
			case 'discount':
				return 'Discount can not be empty or 0';
			case 'purchase_rate':
				return 'Purchase Rate can not be greater than MRP or be empty';
			case 'rate':
				return 'Rate can not be 0 or be empty';
			case 'sale_rate':
				return 'Sale Rate must be greater than and equal to purchase rate and less than MRP';
			case 'trade_rate':
				return 'Trade Rate can not be empty';
			case 'free_quantity':
				return 'Free Quantity can not be more than Quantity';
			case 'exp_date':
			case 'expiry_date':
				return 'EXP Date can not be less than MFG date';
			case 'expiry':
				return 'EXP Date can not empty';
			case 'account':
				return 'Account can not empty';
			case 'tax':
				return 'Tax can not empty';
			case 'net_amount':
				return 'Net Amount can not empty';
			case 'final_amount':
				return 'Final Amount can not empty';
			case 'product_id':
				return customErrorMessage?.product_id || 'Please select a valid product from the list';
			case 'product_name':
				return customErrorMessage?.product_name || 'Please select a valid product from the list';
			case 'return_type_id':
				return 'Please select a valid return type from the list';
			case 'invoice_id':
				return 'Please select a valid invoice number from the list';
			case 'batch_id':
				return 'Batch No can not be empty';
			case 'quantity_adjusted':
				return `Quantity Adjusted can not zero or it can not be greater than Quantity Available`;
			default:
				return '';
		}
	};

	return (
		<div className="modal-productDetail">
			<div
				className="modal-backdrop modal_outer right_modal"
				onClick={onClose}
			>
				<div
					class="modal-dialog"
					role="document"
				>
					<div
						className="modal-content"
						onClick={(e) => e.stopPropagation()}
					>
						<div className="modal-header border-0">
							<span className="modal-title">{title}</span>
							<button
								className="close-button"
								type="button"
								onClick={onClose}
							>
								&times;
							</button>
						</div>
						<div style={{ height: '95vh', overflowY: 'auto' }}>
							{error?.length > 0 &&
								createNestedArray(error)?.map((ele, ind) => {
									return (
										<>
											<b className="m-2"> Line No : {ind + 1} </b>
											<ul className="m-2">
												{ele?.map((item) => {
													return (
														<li>{GetErrorData(item?.message, item?.customErrorMessage || '')}</li>
													);
												})}
											</ul>
										</>
									);
								})}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ErrorModal;
